export default __webpack_public_path__ + "static/2-07416e76616f150ff5adbb9940748065.jpeg";